import { Delete, LayersClear } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import SearchableSelect from "./SearchableSelect";

const CreateConditions = ({
  condition = [],
  onFiledChange,
  onDelete,
  onAdd,
  path = [],
  sx = {},
  deleteGroupBtn = null,
}: any) => {
  return (
    <Box
      sx={{
        ...sx,
        "&:has( > .condition-btns .MuiButton-colorError:hover)": {
          borderColor: "error.main",
        },
      }}
    >
      {Array.isArray(condition) && (
        <>
          {condition.map((val: any, i: number) =>
            typeof val === "string" ? (
              <Box key={i} sx={{ maxWidth: 162 }}>
                <FormControl margin="dense" fullWidth>
                  <InputLabel id="select_operator">Operator *</InputLabel>
                  <Select
                    required
                    labelId="select_operator"
                    name="conditional_operator"
                    value={val}
                    label="Operator *"
                    onChange={(e) => onFiledChange(e, [...path, i])} // Pass updated path
                  >
                    <MenuItem value="AND">AND</MenuItem>
                    <MenuItem value="OR">OR</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            ) : Array.isArray(val) ? ( // Nested Group
              <Box key={i}>
                <CreateConditions
                  condition={val}
                  path={[...path, i]} // Pass correct path for recursion
                  onFiledChange={onFiledChange}
                  onDelete={onDelete}
                  onAdd={onAdd}
                  sx={{ border: "1px dashed rgba(0, 0, 0, 0.30)", p: 1, my: 1, borderRadius: 2 }}
                  deleteGroupBtn={
                    <Button
                      size="small"
                      color="error"
                      sx={{ ml: "auto" }}
                      onClick={() => onDelete([...path, i])}
                    >
                      <LayersClear />
                      Group
                    </Button>
                  }
                />
              </Box>
            ) : (
              // Single Condition
              <Box key={i} sx={{ display: "flex", gap: 1 }}>
                <SearchableSelect
                  value={val?.id}
                  onChange={(e: any) => onFiledChange(e, [...path, i])}
                />
                <FormControl fullWidth margin="dense">
                  <InputLabel id="operator">Operator *</InputLabel>
                  <Select
                    required
                    labelId="operator"
                    name="operator"
                    value={val?.operator}
                    label="Operator *"
                    onChange={(e) => onFiledChange(e, [...path, i])}
                  >
                    <MenuItem value="==">==</MenuItem>
                    <MenuItem value="!=">!=</MenuItem>
                    <MenuItem value="<">{"<"}</MenuItem>
                    <MenuItem value=">">{">"}</MenuItem>
                    <MenuItem value="<=">{"<="}</MenuItem>
                    <MenuItem value=">=">{">="}</MenuItem>
                  </Select>
                </FormControl>
                <TextField
                  margin="dense"
                  name="value"
                  label="Value"
                  type="text"
                  value={val?.value}
                  fullWidth
                  onChange={(e) => onFiledChange(e, [...path, i])} // Pass updated path
                />
                <Button
                  color="error"
                  size="small"
                  onClick={() => onDelete([...path, i])}
                  sx={{ minWidth: "max-content" }}
                >
                  <Delete />
                </Button>
              </Box>
            )
          )}
        </>
      )}
      <Box sx={{ display: "flex", gap: 1 }} className="condition-btns">
        <Button size="small" onClick={() => onAdd(path, false)}>
          <AddIcon sx={{ mr: 0.5 }} /> Condition
        </Button>
        <Button size="small" onClick={() => onAdd(path, true)}>
          <AddIcon sx={{ mr: 0.5 }} /> Group
        </Button>
        {deleteGroupBtn}
      </Box>
    </Box>
  );
};

export default CreateConditions;
